// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EyeInvisibleOutlinedSvg from "@ant-design/icons-svg/es/asn/EyeInvisibleOutlined";
import AntdIcon from '../components/AntdIcon';

var EyeInvisibleOutlined = function EyeInvisibleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: EyeInvisibleOutlinedSvg
  }));
};

EyeInvisibleOutlined.displayName = 'EyeInvisibleOutlined';
export default /*#__PURE__*/React.forwardRef(EyeInvisibleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/EyeInvisibleOutlined.js
// module id = 785
// module chunks = 0